// @ts-nocheck
import { useState } from 'react';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import { useSelector, useDispatch } from 'react-redux';
import { API_ENDPOINTS } from '../const/ApiEndpoints';
import { selectAuth, selectPanel } from '../state/slices/appSlice';
import { setUserData as setUserDataSlice } from '../state/slices/commonSlice';

const useUser = () => {
  const { user } = useSelector(selectAuth);
  const { panelNavigation } = useSelector(selectPanel);
  const [profileUpdated, setprofileUpdated] = useState([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [userData, setUserData] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  /**
   * @function getUserData
   * @description A function to fetch user's data
   * @returns {Promise} returns an axios promise
   */
  const getUserData = () => {
    setIsLoading(true);
    return axios.get(API_ENDPOINTS.GET_USER_DATA, { loader: false }).then(
      (response) => {
        if (response?.data) {
          setUserData(response?.data);
          dispatch(setUserDataSlice(response?.data));
          setIsLoading(false);
        }
      },
      (e) => {
        setIsLoading(false);
        setIsError(e);
      }
    );
  };
  /**
   * @function updateProfile
   * @description A function to update user's profile
   * @returns {Promise} returns an axios promise
   */
  const updateProfile = (data) => {
    const param = { ...data };

    if (param.listType && Array.isArray(param.listType)) {
      param.listType.forEach((item) => {
        param[item] = true;
      });
      delete param.listType;
    }

    setIsLoading(true);

    return axios
      .patch(API_ENDPOINTS.PROFILE_UPDATE, param)
      .then(
        (response) => {
          if (response?.data) {
            setprofileUpdated(response?.data);

            return getUserData().then(() => {
              enqueueSnackbar(response?.data?.Msg, {
                variant: 'success',
              });
            });
          }
        },
        (e) => {
          setIsLoading(false);
          setIsError(e);
        }
      )
      .finally(() => {
        setIsLoading(false);
      });
  };
  return {
    isError,
    isLoading,
    profileUpdated,
    updateProfile,
    getUserData,
    userData,
    panelNavigation,
    user,
  };
};
export default useUser;
